document.addEventListener('keydown', event => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.mobile-menu[open]').forEach(menu => {
    menu.open = false;
    menu.querySelector('summary').focus();
  });
});
document.addEventListener('click', event => {
  const menu = document.querySelector('.mobile-menu[open]');
  if (menu && !menu.contains(event.target)) menu.open = false;
});
